import { render, staticRenderFns } from "./ContentImpressum.vue?vue&type=template&id=3c62a25d&scoped=true&"
import script from "./ContentImpressum.vue?vue&type=script&lang=js&"
export * from "./ContentImpressum.vue?vue&type=script&lang=js&"
import style0 from "./ContentImpressum.vue?vue&type=style&index=0&id=3c62a25d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c62a25d",
  null
  
)

export default component.exports